<script>
import ResourceService from '@/services/resources/applications_service';
import SiteView from './SiteView.vue';

export default {
  extends: SiteView,
  components: {
    ActionBar: () => import('@/components/action_bars/ApplicationsActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-application-import',
      urlFragment: 'applications',
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Location', value: 'location' },
        { text: 'Code', value: 'code' },
        { text: 'Updated', value: 'updatedAt' },
      ],
      sortBy: ['name'],
    };
  },
  computed: {
    resourceParams() {
      return {
        filter: {
          site: this.siteId,
        },
      };
    },
  },
};
</script>
